import React from "react";
import {
  FaCommentAlt,
  FaRegCommentAlt,
  FaRegPaperPlane,
} from "react-icons/fa";
import dashprofile from "../../../../../images/avatar/3.jpg";
import DashMenu from "../../../../atoms/DashMenu/DashMenu";
import SubHeader from "../../../../atoms/SubHeader/SubHeader";
import "./Message.css";

const Message = ({ toggleMenu, showMenu }) => {
  return (
    <div className="dashboard-home-wrapper">
      <div className="dashmenu-style">
        <DashMenu toggleMenu={toggleMenu} showMenu={showMenu} />
      </div>{" "}
      <SubHeader title={"MESSAGE"}/>
      <div className="dash-message-content-wrapper">
        <div className="message-box message-box1">
          <div className="message-header">
            <div className="msg-left">
              <FaCommentAlt className="userprofile" />
              <h3>Last Messages</h3>
              <h4>(+3 New)</h4>
            </div>
            <div className="msg-right">
              <FaRegCommentAlt className="userprofile" />
            </div>
          </div>
        </div>
        <div className="message-box message-box2">
          <div className="message-content">
            <div className="msg-chat">
              <img src={dashprofile} alt="" />
              <h5>ANDY</h5>
            </div>
            <div className="msg-chatt">
              <h6>25 may 2018 7:45PM</h6>
              <p className="msg-p">
                Vivamus lobortis vel nibh nec maximus. Donec dolor erat, rutrum
                ut feugiat sed, ornare vitae nunc. Donec massa nisl, bibendum id
                ultrices sed, accumsan sed dolor.
              </p>
            </div>
          </div>
          <div className="message-content1">
            <div className="msg-chatt1">
              <h6>25 may 2018 7:45PM</h6>
              <p className="msg-p1">
                Vivamus lobortis vel nibh nec maximus. Donec dolor erat, rutrum
                ut feugiat sed, ornare vitae nunc. Donec massa nisl, bibendum id
                ultrices sed, accumsan sed dolor.
              </p>
            </div>
            <div className="msg-chat1">
              <img src={dashprofile} alt="" />
              <h5>ANDY</h5>
            </div>
          </div>
          <div className="message-content">
            <div className="msg-chat">
              <img src={dashprofile} alt="" />
              <h5>ANDY</h5>
            </div>
            <div className="msg-chatt">
              <h6>25 may 2018 7:45PM</h6>
              <p className="msg-p">
                Vivamus lobortis vel nibh nec maximus. Donec dolor erat, rutrum
                ut feugiat sed, ornare vitae nunc. Donec massa nisl, bibendum id
                ultrices sed, accumsan sed dolor.
              </p>
            </div>
          </div>
          <div className="message-content1">
            <div className="msg-chatt1">
              <h6>25 may 2018 7:45PM</h6>
              <p className="msg-p1">
                Vivamus lobortis vel nibh nec maximus. Donec dolor erat, rutrum
                ut feugiat sed, ornare vitae nunc. Donec massa nisl, bibendum id
                ultrices sed, accumsan sed dolor.
              </p>
            </div>
            <div className="msg-chat1">
              <img src={dashprofile} alt="" />
              <h5>ANDY</h5>
            </div>
          </div>
          <div className="message-submit">
            <input type="text" placeholder="Type Message" />
            <button>
              <FaRegPaperPlane />
            </button>
          </div>
        </div>
        <div className="message-box message-box3">
          <div className="home-box home-box3">
            <div className="home-box-message">
              <div>
                <img src={dashprofile} alt="hhhhh" />
              </div>
              <div className="home-box-test">
                <div className="home-box-inner">
                  <h5>Mark Rose</h5>
                  <p>27 Dec 2018</p>
                </div>
                <h2>
                  Lorem ipsum dolor sit amet, voluptates mollitia obcaecati
                  officiis vero vel aliquid reiciendis repellat laboriosam
                  autem?
                </h2>
              </div>
            </div>
            <div className="home-box-message">
              <div>
                <img src={dashprofile} alt="hhhhh" />
              </div>
              <div className="home-box-test">
                <div className="home-box-inner">
                  <h5>Mark Rose</h5>
                  <p>27 Dec 2018</p>
                </div>
                <h2>
                  Lorem ipsum dolor sit amet, voluptates mollitia obcaecati
                  officiis vero vel aliquid reiciendis repellat laboriosam
                  autem?
                </h2>
              </div>
            </div>
            <div className="home-box-message">
              <div>
                <img src={dashprofile} alt="hhhhh" />
              </div>
              <div className="home-box-test">
                <div className="home-box-inner">
                  <h5>Mark Rose</h5>
                  <p>27 Dec 2018</p>
                </div>
                <h2>
                  Lorem ipsum dolor sit amet, voluptates mollitia obcaecati
                  officiis vero vel aliquid reiciendis repellat laboriosam
                  autem?
                </h2>
              </div>
            </div>
            <div className="home-box-message">
              <div>
                <img src={dashprofile} alt="hhhhh" />
              </div>
              <div className="home-box-test">
                <div className="home-box-inner">
                  <h5>Mark Rose</h5>
                  <p>27 Dec 2018</p>
                </div>
                <h2>
                  Lorem ipsum dolor sit amet, voluptates mollitia obcaecati
                  officiis vero vel aliquid reiciendis repellat laboriosam
                  autem?
                </h2>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Message;
